import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { TopUpQuery, EntityDataByBusinessIdVo } from './type';

/**
 * 根据业务查询游戏
  GET /product/urlMapping/game-service/getEntityDataByTopUpVo
  接口ID：257336688
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257336688
 */
export const getTopUpGames = (params: TopUpQuery): AxiosPromise<EntityDataByBusinessIdVo> => {
  return request({
    url: '/product/urlMapping/game-service/getEntityDataByTopUpVo',
    method: 'get',
    params
  });
};
